<template>
  <div class="exam">
    <div v-if="hasData">
      <div class="title">
        <p> {{title}} -（计划测试{{this.count}}道题）</p>
      </div>
      <div class="content">
        <router-view class="router-view">
        </router-view>
        <div class="self-exam">
          <van-exam-title
            v-for="(quiz,index) in quizzes"
            :key="index"
            :title="quiz.name"
          >
            <div v-if="quiz.code === 'DX'">
              <div
                class="word"
                v-for="word in quiz.words"
                :key="word.id"
              >
                <van-dx
                  :testbank="word"
                  @changeRadio="(value) => {commit(word.id, value)}"
                  :is-finish="isFinish"
                  :isListen ="quiz.mode === 2"
                  :type-name="quiz.name"
                ></van-dx>
              </div>
            </div>
            <el-row :gutter="40" v-if="quiz.code === 'TX'">
              <el-col
                :span="12"
                class="word"
                v-for="word in quiz.words"
                :key="word.id"
              >
                <van-tx
                  :testbank="word"
                  :is-finish="isFinish"
                  :is-listen="true"
                  :type-name="quiz.name"
                  @changeText="(value) => {commit(word.id, value)}"
                ></van-tx>
              </el-col>
            </el-row>
          </van-exam-title>
          <div class="submit">
            <el-button
              v-if="!isFinish"
              type="primary"
              size="medium"
              @click="getResult"
            >交卷</el-button>
            <el-button v-else type="primary" size="medium" @click="closeWindow">关闭窗口</el-button>
          </div>
          <el-dialog :visible.sync="dialogVisible" :title=panelTitle>
            <div class="result-panel">
              <div class="remark">
                <p v-if="score>=90">太棒了本次测试<span class="num">{{score}}</span>分</p>
                <p v-if="score>=60 && score<90">还不错！本次测试
                  <span class="num">{{score}}</span>
                  分<br>
                  继续努力吧！
                </p>
                <p v-if="score>=1 && score<60">有点可惜！本次测试
                  <span class="num">{{score}}</span>
                  分<br>
                  没关系！加油！加油！加油！
                </p>
                <p v-if="score==0">很遗憾！本次测试
                  <span class="num">{{score}}</span>
                  分<br>
                  没关系！调整状态，继续努力吧！
                </p>
                <p>获得<span class="num">{{force}}</span>个星耀值</p>
              </div>
              <div class="result">
                <div class="status">
                  <img src="https://img1.wxzxzj.com/vued4e501cbf5d38d4ef853673075d65c8b4.png" alt="">
                  <div class="pass" v-if="resultScore">
                    <img src="https://img1.wxzxzj.com/vued0c9ad0e895d8eae74cdc9d62d1ee8ac7.png" alt="pass">
                  </div>
                  <div class="fail" v-else>
                    <img src="https://img1.wxzxzj.com/vuedd747e4e15c407712cb028fb17fe3890c.png" alt="fail">
                  </div>
                </div>
                <div class="perfect" v-if="resultScore">
                  <img src="https://img1.wxzxzj.com/vued417e3015ecc2206c97647f8cd26029f8.gif" alt="">
                </div>
              </div>
              <div>
                <el-button type="primary" size="medium" @click="closeDialog">查看结果</el-button>
                <el-button type="primary" size="medium" @click="closeWindow">关闭窗口</el-button>
              </div>
              <div>
                <p class="tips">所有 [体验课] 的测试均不奖励星耀值，快去订阅课程获取星耀值吧！</p>
              </div>
            </div>
          </el-dialog>
          <div class="timer">
            {{translateTime}}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-data">
      <p>数据跑丢了~ 请返回“学习中心”，刷新后重新打开测试卷~</p>
    </div>
  </div>
</template>

<script>
import VanExamTitle from '@/components/exam/ExamTitle.vue';
import VanDx from '@/components/exam/DX.vue';
import VanTx from '@/components/exam/TX.vue';
import api from '@/api/graphql/exam/index';
import utils from '@/services/utils';
import AudioPlayer from '@/services/audio-player';
import {
  Dialog,
  Button,
  Row,
  Col,
} from 'element-ui';

export default {
  components: {
    VanExamTitle,
    VanDx,
    VanTx,
    ElRow: Row,
    ElCol: Col,
    ElDialog: Dialog,
    ElButton: Button,
  },
  data() {
    return {
      dialogVisible: false,
      isFinish: false,
      totalTime: 0,
      rightCount: 0,
      hasData: true,
      score: 0,
      force: 0,
      count: 0,
      title: '',
      result: [],
      quizzes: null,
      routerParams: {
        scene: 'course',
      },
    };
  },
  computed: {
    translateTime() {
      let time = this.totalTime;
      const hour = parseInt(time / 3600, 10);
      time -= hour * 3600;
      const minute = parseInt(time / 60, 10);
      const second = time - minute * 60;
      let str = hour >= 10 ? hour : `0${hour}`;
      str += ':';
      str += minute >= 10 ? minute : `0${minute}`;
      str += ':';
      str += second >= 10 ? second : `0${second}`;
      return str;
    },
    resultScore() {
      return this.score >= 90;
    },
    panelTitle() {
      return `测试结果【共${this.count}道题，答对${this.rightCount}道，答错${this.count - this.rightCount}道】`;
    },
  },
  methods: {
    //  获取结果
    getResult() {
      this.isFinish = true;
      clearInterval(this.timer);
      this.resultWords();
      const seconds = this.totalTime;
      const yourAnswer = this.result.map((item) => {
        const { id, result } = item;
        return {
          id,
          result,
        };
      });
      const words = yourAnswer.map(item => item.id);
      this.submitExamResult({
        ...this.routerParams,
        seconds,
        words: yourAnswer,
        record: { words },
      });
    },
    //  单选结果
    resultWords() {
      this.result.forEach((item) => {
        this.rightCount += item.result;
      });
    },
    //  关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    },
    //  关闭窗口
    closeWindow() {
      const { userAgent } = navigator;
      if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
        window.location.href = 'about:blank';
        window.close();
      } else {
        window.opener = null;
        window.open('', '_self');
        window.close();
      }
    },
    //  计时
    timing() {
      this.timer = setInterval(() => {
        this.totalTime += 1;
        // if (this.totalTime === 0) {
        //   this.getResult();
        //   clearInterval(this.timer);
        // }
      }, 1000);
    },
    commit(id, value) {
      const { typeName, result } = value;
      this.result.forEach((item) => {
        if (typeName === item.typeName) {
          item.result = result;
        }
      });
    },
    initReslut() {
      // const num = 0;
      this.quizzes.forEach((quiz) => {
        quiz.words.forEach((word) => {
          // this.result[word.id] = 0;
          // this.result.num = num;
          this.result.push({
            typeName: quiz.name + word.id,
            id: word.id,
            result: 0,
          });
        });
      });
    },
    submitExamResult(variables = {}) {
      api
        .submitExamResult(variables)
        .then(({ submitExamResult }) => {
          this.score = submitExamResult.score;
          this.force = submitExamResult.force;
          this.dialogVisible = true;
          if (this.score > 89) {
            AudioPlayer.play('https://media.wxzxzj.com/vthf8129653856870bf233eb40da74b65a420190117101210.mp3');
          } else {
            AudioPlayer.play('https://media.wxzxzj.com/vthc2453c1fbf96ad7190e1df0d415c04ea20190117101232.mp3');
          }
        });
    },
    getExamData() {
      api.examData(
        this.routerParams,
      ).then(({ examData }) => {
        if (examData) {
          const { summary, quizzes } = examData;
          this.count = summary.total;
          this.title = summary.title;
          this.quizzes = quizzes;
          // this.totalTime = this.count * 6;
          this.timing();
          this.initReslut();
        } else {
          this.hasData = false;
        }
      });
    },
  },
  mounted() {
    this.routerParams.courseId = utils.params('courseId');
    this.routerParams.modeId = utils.params('modeId');
    this.routerParams.unitId = utils.params('unitId');
    if (utils.params('types')) {
      this.routerParams.types = utils.params('types').split(',');
    }
    if (utils.params('quantity')) {
      this.routerParams.quantity = utils.params('quantity');
    }
    this.getExamData();
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .exam {
    .title {
      background: $grey;
      p {
        width: 860px;
        margin: 0 auto;
        color: #fff;
        font-size: 20px;
        line-height: 30px;
      }
    }
    .content {
      width: 860px;
      margin: 20px auto 0;
    }
    .self-exam {
      width: 100%;
      .word {
        padding-top: 20px;
      }
    }
    .submit {
      padding: 80px 0 20px;
      text-align: center;
      border: 1px solid #c0c0c0;
      border-top: none;
      .el-button {
        padding: 10px 30px;
        font-size: $font-size;
        line-height: 20px;
      }
    }
    .panel-title {
      background: $primary;
    }
    .result-panel {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .remark {
        font-size:32px;
        line-height: 55px;
        color: $primary;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
        p{
          margin: 0;
          .num {
            font-size: 50px;
            color: $danger;
          }
        }
      }
      .result {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0 20px 30px;
        .status {
          position: relative;
          margin-right: 40px;
          .pass{
            position: absolute;
            top: -20px;
            left: 5px;
          }
          .fail{
            position: absolute;
            bottom: 5px;
            left: 5px;
          }
        }
      }
      .tips {
        margin: 20px 0 0;
        color: $grey-color;
      }
    }
    .timer {
      position: fixed;
      right: 80px;
      top: 50px;
      font-size: 32px;
      font-weight: bold;
      color: $danger;
    }
    .no-data{
      min-height: 400px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      color: $font-color;
    }
  }
</style>
